import { Stack, Skeleton } from '@mui/material';

type Props = {
  rows?: number;
  loading: boolean;
  children?: React.ReactNode;
};

export default function NotificationSkeleton({ rows = 1, loading, children }: Props) {
  if (loading) {
    const array = Array.from({ length: rows }, (_, index) => index);

    return array.map((index) => (
      <Stack
        spacing={2}
        direction="row"
        alignItems="center"
        key={index}
        sx={{
          p: 2.5,
          alignItems: 'flex-start',
          border: (theme) => `dashed 1px ${theme.palette.divider}`,
        }}
      >
        <Skeleton sx={{ borderRadius: 1, width: 40, height: 40, flexShrink: 0 }} />

        <Stack spacing={1} justifyItems="center">
          <Skeleton sx={{ width: 180, height: 12 }} />
          <Skeleton sx={{ width: 120, height: 12 }} />
        </Stack>
      </Stack>
    ));
  }

  return children;
}
